import React from "react";
import { Box } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

function BeneficiarioNomeIdAlinhadoDireita() {
  const location = useLocation();


  return (
    // <Box
    //   sx={{
    //     fontWeight: 500,
    //     fontFamily: "candara",
    //     fontSize: 18,
    //     display: "flex",
    //     justifyContent: "end",
    //     // color: "#7e2706",
    //     m: 1,
    //   }}
    // >
    <div style={{
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'space-between'
    }}>

      <Stack>
        <Typography
          variant="subtitle1"
          fontWeight={500}
          fontFamily="candara"
          fontSize={18}
          marginRight={5}
        >
          Caderno para: {location.state.cultura_caderno}
        </Typography>
      </Stack>

      <Stack direction="row">


        <Typography
          variant="subtitle1"
          fontWeight={500}
          fontFamily="candara"
          fontSize={18}
          marginRight={5}
        >
          Beneficiário: {location.state.nome}
        </Typography>

        <Typography
          variant="subtitle1"
          fontWeight={500}
          fontFamily="candara"
          fontSize={18}
        >
          NIF: {location.state.nif}
        </Typography>
      </Stack>
      {/* </Box> */}
    </div>

  );
}

export default BeneficiarioNomeIdAlinhadoDireita;
